export default __webpack_public_path__ + "static/refi-expert-1-5649e2d337564fdbe121292f961fcfc0.png";